//----------------------------------------------------------------------
// views/layoutsにある一部のファイルのheadの中で他のJSファイルを含めないで
// rails_ujsだけを先にロードするため、pc_application.jsなどには含めていない
//
// TODO: UJSはRails6から非推奨になるためRails7のturboへ移行する。
//----------------------------------------------------------------------
const Rails = require("@rails/ujs"); // NOTE: importを使用すると自動的にrails-ujs.esm.jsが読み込まれ, その一部のコードがエラーになるためrequireを使用

Rails.start();
